<template>
  <section
    v-if="productGeometry"
    :id="uid"
    :key="`geometry-container-${productCode}`"
    class="sizing-and-fit-aftermarket-component sizing-table container mb-6"
  >
    <pdl-heading class="mb-1" level="2" size="lg">{{ $t('text.geometry') }}</pdl-heading>
    <advanced-geometry-chart
      v-if="productGeometry.geometryChartScriptURL"
      :geometry-chart-script-url="productGeometry.geometryChartScriptURL"
    />
    <div v-else>
      <div v-if="content" class="w-full mb-4">
        <p class="font-light">{{ content }}</p>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div id="spec-chart__container" class="col-span-12 md:col-span-5">
          <div v-if="productGeometry.assetIdGeometry" class="sizing-table__bike-image">
            <image-component
              :asset-id="productGeometry.assetIdGeometry"
              img-format="pjpg"
              aspect-ratio="4x3"
              transformation="pad"
              :alt-text="$t('product.geometry.imgTitle')"
              :caption-text="$t('product.geometry.figCaption')"
            />
          </div>
        </div>
        <div class="col-span-12 md:col-span-7">
          <p
            id="sizing-table__disclaimer"
            class="sizing-table__disclaimer mb-1 text-left"
            v-html="$t('product.size.fit.info')"
          />
          <table id="sizing-table" class="sizing-table__table">
            <caption class="sr-only">
              Sizing table
            </caption>
            <thead class="sizing-table__head">
              <tr class="sizing-table__head-row">
                <th
                  v-for="(entry, index) in productGeometry.geometryDataHeaders"
                  :key="index"
                  class="sizing-table__header px-2 py-25 text-xs font-semibold"
                  scope="row"
                >
                  <span v-if="indicators[entry]" class="sizing-table__alias">{{ indicators[entry] }} &mdash; </span>
                  {{ $t(`product.geometry.${entry}`) }}
                </th>
              </tr>
            </thead>
            <tbody class="sizing-table__body">
              <tr v-for="(column, index) in geometryRows" :key="index" class="sizing-table__body-row">
                <td v-for="entry in column" :key="entry" class="sizing-table__data px-2 py-25 text-xs">
                  {{ entry ?? '&nbsp;' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex';
import {ProductApi} from '@/api/product';
import AdvancedGeometryChart from '@/components/pdp-widgets/AdvancedGeometryChart.vue';
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlHeading} from '@pedal/pdl-section-header';
export default {
  name: 'GeometryContainer',
  components: {AdvancedGeometryChart, ImageComponent, PdlHeading},
  props: {
    uid: {
      type: String,
      default: undefined,
    },
    content: {
      type: String,
      default: undefined,
    },
    productCode: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      productGeometry: null,
      indicators: {
        geometrySeattube: 'A',
        geometryAngleSeattube: 'B',
        geometryLengthHeadtube: 'C',
        geometryAngleHead: 'D',
        geometryEffToptube: 'E',
        geometryBBHeight: 'F',
        geometryBBDrop: 'G',
        geometryLengthChainstay: 'H',
        geometryOffset: 'I',
        geometryTrail: 'J',
        geometryWheelbase: 'K',
        geometryStandover: 'L',
        geometryFrameReach: 'M',
        geometryFrameStack: 'N',
      },
    };
  },
  computed: {
    ...mapState('backend', ['b2b', 'isB2Bsite', 'currentB2BUnit']),
    geometryRows() {
      return this.productGeometry?.geometryData.map((row) => row.geometry);
    },
  },
  watch: {
    productCode: {
      handler() {
        this.fetchGeometryData();
      },
      immediate: true,
    },
  },
  methods: {
    async fetchGeometryData() {
      try {
        if (!this.productCode) return;
        this.productGeometry = await ProductApi.fetchProductSizingData(
          this.productCode,
          this.isB2Bsite,
          this.currentB2BUnit
        );
      } catch (error) {
        console.error('Error fetching geometry data:', error);
      }
    },
  },
};
</script>
